import { render, staticRenderFns } from "./ResultDialog.vue?vue&type=template&id=132526b0&scoped=true&"
import script from "./ResultDialog.vue?vue&type=script&lang=js&"
export * from "./ResultDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132526b0",
  null
  
)

export default component.exports